export const OPEN_WIZARD_EVENT = 'FMF/OPEN_WIZARD';
export const CLOSE_WIZARD_EVENT = 'FMF/CLOSE_WIZARD';
export const WIZARD_OPENED_EVENT = 'FMF/WIZARD_OPENED';
